/**
 * 判断url是否是http或https 
 * @param {string} path
 * @returns {Boolean}
 */
 export function isHttp(url) {
  return url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1
}

/**
 * 判断path是否为外链
 * @param {string} path
 * @returns {Boolean}
 */
 export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}


// 非法文件名规则配置
const FILE_NAME_RULES = {
  // 禁止的特殊字符
  forbiddenChars: /[<>:"/\\|?*()+\s]/,
  // 禁止的Windows保留名称
  reservedNames: /^(CON|PRN|AUX|NUL|COM[1-9]|LPT[1-9])(\..*)?$/i,
  // 禁止以点或空格结尾
  trailingDotsOrSpaces: /[.\s]$/,
  // 最大文件名长度（含扩展名）
  maxLength: 255,
};
export function validateFileName(fileName) {
  // 1. 检查是否为空
  if (!fileName || fileName.trim() === '') {
    return { valid: false, message: '文件名不能为空' };
  }

  // 2. 检查长度
  if (fileName.length > FILE_NAME_RULES.maxLength) {
    return { valid: false, message: `文件名长度不能超过${FILE_NAME_RULES.maxLength}个字符` };
  }

  // 3. 检查特殊字符
  if (FILE_NAME_RULES.forbiddenChars.test(fileName)) {
    return {
      valid: false,
      message: '文件名不能包含尖括号<>、括号（）、冒号:、正斜杠/、反斜杠\\、竖线|、问号?、星号*、加号+等非法字符',
    };
  }

  // 4. 检查Windows保留名称
  if (FILE_NAME_RULES.reservedNames.test(fileName)) {
    return {
      valid: false,
      message: '文件名不能使用系统保留名称（如CON, PRN, AUX, NUL等）',
    };
  }

  // 5. 检查尾部点或空格
  if (FILE_NAME_RULES.trailingDotsOrSpaces.test(fileName)) {
    return {
      valid: false,
      message: '文件名不能以点或空格结尾',
    };
  }

  return { valid: true, message: '文件名合法' };
}
